import React from 'react';

function MainHeading(props) {
  const {title, classes} = props;
  return (
    <h1 className={`heading-color font-24 text-capitalize  text-bold ${classes}`}>{title}</h1>
  );
}

export default MainHeading;
